<template>
    <BaseFileUpload
        v-slot="{ clickInput }"
        :is-multiple-file-upload-enabled="true"
        :accepted-file-types="acceptedFileTypes"
        :is-disabled="isUploading"
        :is-document-dropzone-enabled="true"
        @file-upload="(files: File[]) => emit('fileUpload', files)">
        <div class="border-2 border-dashed rounded-lgr p-6 text-center border-valence-grey-300 hover:border-valence-primary-500 hover:bg-valence-primary-50 transition-colors">
            <i class="bi bi-cloud-upload text-2xl text-valence-grey-500" aria-hidden="true"></i>
            <p class="body-small text-valence-grey-750 mt-1">Drag and drop files here, or</p>
            <BaseButton theme="neutral" size="sm" :disabled="isUploading" class="mt-2 inline-flex items-center gap-2 rounded-lgr" @click="clickInput">
                <LoadingSpinner v-if="isUploading" class="h-4 w-4" />
                Browse Files
            </BaseButton>
            <p class="details text-valence-grey-500 mt-2">
                Supported:
                {{
                    acceptedFileTypes
                        .split(",")
                        .map((t) => t.replace(".", "").toUpperCase())
                        .join(", ")
                }}
            </p>
        </div>
    </BaseFileUpload>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseFileUpload from "~vue/components/BaseFileUpload.vue";
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";

defineProps<{
    acceptedFileTypes: string;
    isUploading: boolean;
}>();

const emit = defineEmits<{ fileUpload: [files: File[]] }>();
</script>
